import React from 'react'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import Img from 'gatsby-image'
import useForm from 'react-hook-form';
import { Checkbox, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@material-ui/core';
import { EMAIL_PATTERN, NUMBER_PATTERN, NAME_PATTERN, NAME_MIN_LENGTH } from '../../../state/constants/appConstants';
import LeafletIndicator from '../leaflet-indicator/leaflet-indicator';
import Alert from '../../atoms/alert/alert';
import Icon from '../../atoms/Icon/Icon';
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import useDocument from '../../../hooks/useDocument';
import ArticleService from '../../../services/articles';
import RegisterService from '../../../services/register';
import InputMaterial from '../../atoms/input-material/input-material';
import Button from '../../atoms/Button/Button';
import ButtonLoading from "../buttonLoading/buttonLoading";
import './leaflet-card.scss'

const LeafletCard = props => {
    const options = {
        renderNode: {
            [BLOCKS.HEADING_2]: (node, next) => <h2 className="f-leaflet-card-content-header-title">{next}</h2>,
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-leaflet-card-content-header-description" >{next}</p>
        }
    };

    const [activeStep, setActiveStep] = React.useState(1);
    const [isRegisteredAndMustUpdate, setRegisteredAndMustUpdate] = React.useState(false);
    const [terms, setTerms] = React.useState(null);
    const [politics, setPolitics] = React.useState(null);
    const { homeLink } = useHomeLinkMode();
    const documentInfo = useDocument();
    const [userData, setUserData] = React.useState({
        email: "",
        cellPhone: ""
    })
    // const [contentToRender, setContentToRender] = React.useState(1);
    const [isLoaderVisible, setLoaderVisible] = React.useState(false);

    //variables for document implementation
    const [documentType, setDocumentType] = React.useState();
    const [documentRegistered, setDocumentRegistered] = React.useState();
    const inputLabel = React.useRef(null);

    const {
        register,
        handleSubmit,
        triggerValidation,
        setValue,
        errors,
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            // address: userData ? userData.address : userDataRegister ? userDataRegister.address : props.migrationData ? props.migrationData.mainAddress : "",
            // neighborhood: userDataRegister ? userDataRegister.neighborhood : ""
        }
    });

    const dataLAyerStepBlur = (e, step) => {
        if (props.isHome) {
            let { value, name } = e.target
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': 'form :: nuestro contenido :: step ' + step,
                'eventAction': 'interaction :: ' + !value || value === '' ? "empty" : "complete",
                'eventLabel': name
            });
        }
    }

    const step1 = () => {
        return (
            <>
                <div className="f-leaflet-card-content-header">
                    {documentToReactComponents(props.leafletContent.informacionPrincipal.json, options)}
                </div>
                <div className="f-leaflet-card-content-body">
                    <form onSubmit={handleSubmit(onSubmit)} className="f-leaflet-card-content-body-form">
                        <InputMaterial
                            change={e => {
                                // setCellPhoneActive(false);
                                triggerValidation({ name: e.target.name });
                            }}
                            blurEvent={(e) => dataLAyerStepBlur(e, 1)}
                            errors={[]}
                            name="email"
                            type="text"
                            autoComplete={false}
                            classes="f-form-input-large"
                            label={props.leafletContent.inputCorreoElectronico}
                            // blurEvent={checkEmailRegister}
                            // messageError={isEmailActive ? errorMessagge : null}
                            register={register({
                                required: { value: true, message: "El correo es requerido." },
                                minLength: { value: 8, message: "Este campo debe contener por lo menos 8 dígitos." },
                                maxLength: { value: 50, message: "Este campo debe contener máximo 50 dígitos." },
                                pattern: { value: EMAIL_PATTERN, message: "El correo ingresado es inválido." }
                            })}
                        />
                        <InputMaterial
                            change={e => {
                                if (e.target.value !== null && e.target.value.length > 0) {
                                    let newValue = e.target.value.replace(/\D/g, '');
                                    setValue("cellPhone", newValue);
                                }
                                triggerValidation({ name: e.target.name });
                            }}
                            blurEvent={(e) => dataLAyerStepBlur(e, 1)}
                            errors={[]}
                            name="cellPhone"
                            type="text"
                            autoComplete={false}
                            classes="f-form-input"
                            label={props.leafletContent.inputCelular}
                            register={register({
                                required: { value: true, message: "Tu número celular es requerido." },
                                pattern: { value: NUMBER_PATTERN, message: "Ingresa sólo números." },
                                minLength: { value: process.env.CELL_DIG, message: `Un número celular debe tener ${process.env.CELL_DIG} dígitos.` },
                                maxLength: { value: process.env.CELL_DIG, message: `Un número celular debe tener ${process.env.CELL_DIG} dígitos.` },
                            })}
                        />
                        {(errors.email || errors.cellPhone) &&
                            <Alert alertType="error-leaflet" description={errors.email ? errors.email.message : errors.cellPhone.message} />}
                        <ButtonLoading
                            button={
                                <Button
                                    type="input"
                                    classname="f-button f-button--primary"
                                    text={props.leafletContent.botonSiguiente}
                                />
                            }
                            isShowingLoader={isLoaderVisible}
                            bgClass="primary"
                        />
                    </form>
                    {!props.isMobile && <LeafletIndicator activeStep={activeStep} />}
                </div>
            </>
        )
    }

    const step2 = () => {
        return (
            <>
                <div className="f-leaflet-card-content-header-step2">
                    {documentToReactComponents(props.leafletContent.informacionPrincipalTitulo.json, options)}
                </div>
                <div className="f-leaflet-card-content-body-step2">
                    <form onSubmit={handleSubmit(onSubmitStep2)} className="f-leaflet-card-content-body-step2-form">
                        <InputMaterial
                            errors={[]}
                            name="name"
                            type="text"
                            autoComplete={false}
                            classes="f-form-input"
                            label={props.leafletContent.inputNombres}
                            blurEvent={(e) => dataLAyerStepBlur(e, 2)}
                            register={register({
                                required: { value: true, message: "El nombre es requerido." },
                                pattern: { value: NAME_PATTERN, message: "El nombre ingresado es inválido." },
                                minLength: { value: NAME_MIN_LENGTH, message: "El nombre debe tener mínimo 3 caracteres." }
                            })}
                        />
                        <InputMaterial
                            errors={[]}
                            name="lastname"
                            type="text"
                            autoComplete={false}
                            classes="f-form-input"
                            label={props.leafletContent.InputApellidos}
                            blurEvent={(e) => dataLAyerStepBlur(e, 2)}
                            register={register({
                                required: { value: true, message: "Los apellidos son requeridos." },
                                pattern: { value: NAME_PATTERN, message: "Los apellidos ingresados son inválidos." },
                                minLength: { value: NAME_MIN_LENGTH, message: "Los apellidos deben tener mínimo 3 caracteres." }
                            })}
                        />
                        <div className="f-terms-wrapper">
                            <Checkbox
                                checked={politics}
                                onChange={event => { setPolitics(event.target.checked) }}
                                onBlur={(e) => dataLAyerStepBlur(e, 2)}
                                value={politics}
                                className={"f-terms-checkbox"}
                                name="policy"
                            />
                            <div className="f-terms"><p>Acepto <a rel="noopener noreferrer" target="_blank" href={homeLink + "politica-de-privacidad/"} >política de uso de datos</a></p></div>
                        </div>
                        <div className="f-terms-wrapper">
                            <Checkbox
                                checked={terms}
                                onChange={event => { setTerms(event.target.checked) }}
                                onBlur={(e) => dataLAyerStepBlur(e, 2)}
                                value={terms}
                                name="terms"
                                className={"f-terms-checkbox"}
                            />
                            <div className="f-terms"><p>Acepto <a rel="noopener noreferrer" target="_blank" href={homeLink + "terminos-y-condiciones/"} >términos y condiciones</a></p></div>
                        </div>
                        {(errors.name || errors.lastname || politics === false || terms === false) &&
                            <Alert alertType="error-leaflet" description={
                                errors.name ? errors.name.message :
                                    errors.lastname ? errors.lastname.message :
                                        !politics ? "Debes aceptar politicas de uso de datos para continuar" :
                                            !terms ? "Debes aceptar términos y condiciones para continuar" :
                                                ""} />}
                        <div className="f-buttons-footer">
                            <div className="f-button-back">
                                <div
                                    className="f-btn-return"
                                    onClick={() => {
                                        setActiveStep(1);
                                    }}
                                >
                                    <Icon icon="icon-arrow-left white" size="3" tagtype="span" />
                                </div>
                            </div>
                            <ButtonLoading
                                button={
                                    <Button
                                        type="input"
                                        classname="f-button f-button--primary"
                                        text={props.leafletContent.botonSiguiente}
                                    />
                                }
                                isShowingLoader={isLoaderVisible}
                                bgClass="primary"
                            />
                        </div>
                    </form>
                    {!props.isMobile && <LeafletIndicator activeStep={activeStep} />}
                </div>
            </>
        )
    }

    //New step document
    const step3 = () => {
        return (
            <>
                <div className="f-leaflet-card-content-header-step2">
                    {documentToReactComponents(props.leafletContent.informacionPrincipalTitulo.json, options)}
                </div>
                <div className="f-leaflet-card-content-body-step2">
                    <form onSubmit={handleSubmit(onSubmitStep3)} className="f-leaflet-card-content-body-step2-form">
                        <FormControl
                            variant="outlined"
                            className="f-select-input f-input-material"
                        >
                            <InputLabel ref={inputLabel} htmlFor="documentType">{" " + documentInfo.inputTipoDeDocumento + " "}</InputLabel>
                            <Select
                                name='documentType'
                                id='documentType'
                                value={documentType ? documentType : ''}
                                onChange={e => setDocumentType(e.target.value)}
                                input={<OutlinedInput labelWidth={0} name="documentType" id="documentType" />}
                                onBlur={(e) => dataLAyerStepBlur(e, 3)}
                            >
                                {documentInfo?.tipoDeDocumento?.map((item, index) => (
                                    <MenuItem key={index} value={item.value}>{item.name}</MenuItem>
                                ))}
                            </Select>
                            <Icon icon="icon-chevron-down lonchmara" size="0-7" tagtype="i" />
                        </FormControl>

                        <InputMaterial
                            errors={[]}
                            name="document"
                            type="text"
                            autoComplete={false}
                            classes="f-form-input"
                            label={documentInfo?.inputNumeroDeDocumento}
                            blurEvent={(e) => dataLAyerStepBlur(e, 3)}
                            register={register({
                                required: { value: true, message: "El documento es requerido." },
                                // pattern: { value: NUMBER_PATTERN, message: "Ingresa sólo números." },
                                minLength: { value: 5, message: "El documento debe tener mínimo 5 caracteres." },
                                maxLength: { value: 15, message: "El documento debe tener máximo 15 caracteres." },
                            })}
                        />

                        {(errors.document || documentType === null || documentRegistered) &&
                            <Alert alertType="error-leaflet" description={errors.document ? errors.document.message : documentRegistered ? documentRegistered : "Debes seleccionar un tipo de documento"} />}

                        <div className="f-buttons-footer f-buttons-footer--step3">
                            <div className="f-button-back">
                                <div
                                    className="f-btn-return"
                                    onClick={() => {
                                        setActiveStep(1);
                                    }}
                                >
                                    <Icon icon="icon-arrow-left white" size="3" tagtype="span" />
                                </div>
                            </div>
                            <ButtonLoading
                                button={
                                    <Button
                                        type="input"
                                        classname="f-button f-button--primary"
                                        text={props.leafletContent.botonFinalizar}
                                    />
                                }
                                isShowingLoader={isLoaderVisible}
                                bgClass="primary"
                            />
                        </div>
                    </form>
                    {!props.isMobile && <LeafletIndicator activeStep={activeStep} />}
                </div>
            </>
        )
    }

    const stepRegistered = () => {
        return (
            <>
                <div className={`${isRegisteredAndMustUpdate ? "f-leaflet-card-content-header-step3 f-leaflet-card-content-header-step3--registered" : "f-leaflet-card-content-header-step3"}`}>
                    {documentToReactComponents(props.leafletContent.registroProspectoYaInscrito.json, options)}
                    {isRegisteredAndMustUpdate &&
                        <Alert alertType="error-leaflet" description="Hay datos que no coinciden con los registrados anteriormente,
                        si deseas actualizar tus datos comunícate con nuestras asesoras." />}
                </div>
                {
                    process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-EC" ? null
                        :
                        <div className="f-leaflet-card-content-body-step3">
                            {props.leafletContent.registroProspectoRecomendados.map((recommended, index) => {
                                return (
                                    <div className="f-recommended-card" key={index}>
                                        {props.isMobile ? null :
                                            <div className="f-recommended-card-image-wrapper">
                                                <img className="f-recommended-card-image" src={recommended.imagen.file.url} alt={recommended.imagen.description} />
                                            </div>}
                                        <Button classname="f-button f-button--primary" type="button" text={recommended.nombreDeEtiqueta} onClickAction={() => { window.location.href = homeLink + recommended.redireccion }} />
                                    </div>
                                )
                            })}
                        </div>
                }

            </>
        )
    }

    const stepSuccessfulRegistration = () => {
        return (
            <>
                <div className="f-leaflet-card-content-header-step4">
                    {documentToReactComponents(props.leafletContent.registroProspectoInscripcionExitosa.json, options)}
                </div>
            </>
        )
    }

    const onSubmit = async data => {
        setLoaderVisible(true);

        if (props.isHome) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': 'form :: nuestro contenido :: step 1',
                'eventAction': 'interaction :: send',
                'eventLabel': 'siguiente'
            });
        }

        let payload = {
            email: data.email,
            cellPhone: process.env.COUNTRY_PHONE_PREFIX + data.cellPhone
        }
        ArticleService.validateEmailAndCell(payload).then(resp => {
            setLoaderVisible(false);
            setUserData(payload);
            if (resp.status === 400) {
                switch (resp.errorCode) {
                    case "DEM011":
                        setActiveStep(4);
                        setRegisteredAndMustUpdate(true);
                        break;
                    case "DEM012":
                        setActiveStep(4);
                        setRegisteredAndMustUpdate(false);
                        break;
                    default:
                        break;
                }
            }
            else if (resp.status === 200) {
                setActiveStep(2);

                if (props.isDescreet) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ 'event': 'ga_event_consultorio', 'category': 'Registro Lite', 'action': 'Click', 'label': 'Inicio Registro', 'value': '' });
                }
            }
        })
            .catch(err => { setLoaderVisible(false); console.log(err) })
    }

    const onSubmitStep2 = async data => {
        if (!politics) {
            setPolitics(false);
        }
        if (!terms) {
            setTerms(false);
        }
        if (terms && politics) {

            if (props.isHome) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'trackEvent',
                    'eventCategory': 'form :: nuestro contenido :: step 2',
                    'eventAction': 'interaction :: send',
                    'eventLabel': 'siguiente'
                });
            }

            let payload = {
                email: userData.email,
                cellPhone: userData.cellPhone,
                name: data.name,
                lastName: data.lastname,
                tycAccepted: 1,
                uytdAccepted: 1,
            }

            setUserData(payload);
            setActiveStep(3);
            if (props.isDescreet) {
                try {
                    dataLayer.push({ 'event': 'ga_event_consultorio', 'category': 'Registro Lite', 'action': 'Click', 'label': 'Paso 2', 'value': '' });
                } catch (error) {
                }
            }

        }
    }

    //Handle send form
    const onSubmitStep3 = async data => {
        //typeDocument validation
        if (!documentType) {
            setDocumentType(null)
            return false
        }

        if (props.isHome) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'trackEvent',
                'eventCategory': 'form :: nuestro contenido :: step 3',
                'eventAction': 'interaction :: send',
                'eventLabel': 'finalizar'
            });
        }

        setLoaderVisible(true)

        const payload = {
            email: userData.email,
            cellPhone: userData.cellPhone,
            name: userData.name,
            lastName: userData.lastName,
            countryRegisterId: process.env.COUNTRY_CODE,
            tycAccepted: 1,
            uytdAccepted: 1,
            typeId: documentType,
            numberId: data.document
        }

        try {
            RegisterService.checkDocument(payload).then(resp => resp).then(resp2 => {
                // console.log("🚀 ~ file: leaflet-card.jsx ~ line 405 ~ RegisterService.checkDocument ~ resp2", resp2)

                setLoaderVisible(false);

                //if document don't exist, register de prospect user
                if (resp2.status === 200) {

                    RegisterService.registerLeaflet(payload).then(resp => {
                        // console.log("🚀 ~ file: leaflet-card.jsx ~ line 417 ~ RegisterService.registerLeaflet ~ resp", resp)
                        if (resp.status === 200) {
                            setActiveStep(5);

                            window.dataLayer = window.dataLayer || [];

                            if (props.isDescreet) {
                                window.dataLayer.push({ 'event': 'ga_event_consultorio', 'category': 'Registro Lite', 'action': 'Click', 'label': 'Registro exitoso', 'value': '' });
                            }

                            if (props.isHome) {
                                window.dataLayer.push({
                                    'event': 'trackEvent',
                                    'eventCategory': 'form :: nuestro contenido :: Registro Lite',
                                    'eventAction': 'interaction :: send',
                                    'eventLabel': 'Registro exitoso'
                                });
                            }
                        }
                    })

                } else if (resp2.status === 400) {

                    setDocumentRegistered(resp2.userMessage)
                    return false

                }
            })
        } catch (error) {
            setLoaderVisible(false); console.log(error)
        }
    }

    return (
        <div className={`f-leaflet-card ${props.isMobile && "f-leaflet-card--mobile"}`}>
            <Img fluid={props.leafletContent.banner[props.isMobile ? 1 : 0].fluid} className="f-leaflet-card-image" />
            {props.isMobile && (activeStep === 1 || activeStep === 2 || activeStep === 3) && <LeafletIndicator isMobile={props.isMobile} activeStep={activeStep} />}
            <div className={`f-leaflet-card-content ${(activeStep === 4 || activeStep === 5) && "f-leaflet-card-content-end"}`}>
                {activeStep === 1 && step1()}
                {activeStep === 2 && step2()}
                {activeStep === 3 && step3()}
                {activeStep === 4 && stepRegistered()}
                {activeStep === 5 && stepSuccessfulRegistration()}
            </div>
        </div>
    )
}

export default LeafletCard
